import { Expose } from "@nts/std/serialization";
import { IdentityTypeNameDecorator } from '../decorators/identity-type-name.decorator';
import { CompanySingleAggregateIdentityInterface } from "@nts/std/interfaces";
import { BaseIdentity } from "../base-identity";

/**
 * Identity per i modelli di configurazione che conterranno sempre e solo un aggregato per ditta(una riga).
 * Non è necessario che estende SingleAggregateIdentity in quanto viene utilizzato il companyId come fixedIdentity
 */
@IdentityTypeNameDecorator('CompanySingleAggregateIdentity')
export class CompanySingleAggregateIdentity extends BaseIdentity implements CompanySingleAggregateIdentityInterface {

  private _companyId: number = 0;

  @Expose()
  get companyId(): number {
    return this.getValue<number>(() => this._companyId, 'companyId');
  }
  set companyId(value: number) {
    this.setValue<number>(() => { this._companyId = value; }, value, 'companyId');
  }

}
